import { memo, useMemo } from "react";
import { Chip, Stack, Typography } from "@mui/material";
import dayjs from "dayjs";
import type { BookingTarget } from "../../booking/types";
import { groupSlotsByDay } from "../helpers/slotDays";
import type { ProviderAgendaSlot } from "../services/providerAgendaService";

/** Horários livres de UM teleconsultor no período, por dia. Um toque marca. */
export const TeleconsultorSlotsPanel = memo(function TeleconsultorSlotsPanel({
  slots,
  onBook,
}: {
  slots: ProviderAgendaSlot[];
  onBook: (target: BookingTarget) => void;
}) {
  const days = useMemo(() => groupSlotsByDay(slots), [slots]);

  if (!days.length) {
    return (
      <Typography variant="body2" color="text.secondary">
        Sem horários livres neste período. Tente outro dia.
      </Typography>
    );
  }

  return (
    <Stack spacing={1.5}>
      {days.map((day) => (
        <Stack key={day.dayKey} spacing={0.75}>
          <Typography variant="caption" fontWeight={700} sx={{ textTransform: "capitalize" }}>
            {day.label}
          </Typography>
          <Stack direction="row" flexWrap="wrap" useFlexGap gap={1}>
            {day.slots.map((slot) => (
              <Chip
                key={slot.slotId}
                clickable
                color="primary"
                variant="outlined"
                label={dayjs(slot.start).format("HH:mm")}
                aria-label={`Marcar às ${dayjs(slot.start).format("HH:mm")} de ${day.label}`}
                onClick={() =>
                  onBook({
                    mode: "slot",
                    agenda: slot.agenda,
                    slotId: slot.slotId,
                    start: slot.start,
                    end: slot.end,
                  })
                }
              />
            ))}
          </Stack>
        </Stack>
      ))}
    </Stack>
  );
});
